import { MARQUEE_ITEMS } from "../../data/content";

export const Marquee = () => {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div data-testid="editorial-marquee" className="relative border-y border-border bg-secondary/40 py-5 overflow-hidden select-none">
      <div className="flex w-max animate-marquee gap-0">
        {items.map((item, i) => (
          <span key={i} className="flex items-center gap-8 pr-8 whitespace-nowrap">
            <span className="font-display text-lg sm:text-xl font-semibold tracking-tight text-muted-foreground">{item}</span>
            <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 shrink-0" />
          </span>
        ))}
      </div>
    </div>
  );
};
